var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRefundImg3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 50,
    viewBox: "0 0 57 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55.6437 2.70361H46.1446V0H43.4294V2.70361H35.2866V0H32.5714V2.70361H24.4286V0H21.7134V2.70361H13.5706V0H10.8554V2.70361H1.35627C0.595406 2.70361 0 3.29906 0 4.05412V50H57V4.05672C57 3.29908 56.402 2.70621 55.6437 2.70621V2.70361ZM36.7243 39.1096L33.8463 41.9754L28.5 36.6519L23.1537 41.9754L20.2757 39.1096L25.622 33.7861L20.2757 28.4625L23.1537 25.5968L28.5 30.9203L33.8463 25.5968L36.7243 28.4625L31.378 33.7861L36.7243 39.1096ZM2.71515 5.40723H10.858V8.11084H13.5732V5.40723H21.716V8.11084H24.4312V5.40723H32.574V8.11084H35.2892V5.40723H43.432V8.11084H46.1472V5.40723H54.2901V13.5155H2.71515V5.40723Z",
    fill: "#00A9DD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefundImg3);
export default __webpack_public_path__ + "static/media/RefundImg3.8e6772c222fb5989e4207ce1640891b9.svg";
export { ForwardRef as ReactComponent };